export interface Medication {
  medId: number | string;
  order?: number;
  customMed?: boolean;
  orderStatusCode?: string;
  amt?: {
    mpId?: string;
    mpuuId?: string;
    tpuuId?: string;
  };
  relatedPathology?: string;
  medName: string;
  brand?: string;
  subheading?: string;
  furtherInformation?: string;
  indication?: string;
  indicationDescription?: string;
  medChangeType?: string;
  furtherDescriptionOfChange?: string;
  isDeleted?: boolean | null;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  regimen?: {
    isDoseSchedule?: boolean;
    doseSchedule?: {
      isBreakfast?: boolean;
      breakfastNote?: string;
      isLunch?: boolean;
      lunchNote?: string;
      isDinner?: boolean;
      dinnerNote?: string;
      isBed?: boolean;
      bedNote?: string;
    };
    isPrn?: boolean;
    prn?: {
      prnNote?: string;
    };
    isTaper?: boolean;
    taper?: {
      dosingSchedule?: string;
      taperTitle?: string;
      taperHeaders?: string[];
      taperSchedule?: {
        values?: string[];
      }[];
    };
  };
}

// Consolidated shared aliases for reuse across app
export type MedicationRegimen = NonNullable<Medication['regimen']>;
export type MedicationDetails = Omit<
  Partial<Medication>,
  'medId' | 'medName'
> & {
  medId: number;
  medName: string;
};

export type Taper = NonNullable<MedicationRegimen['taper']>;

export const tranformTaperFormat = (taper: any): Taper => {
  return {
    dosingSchedule: taper?.dosingSchedule || '',
    taperTitle: taper?.taperTitle || '',
    taperHeaders:
      taper?.taperHeaders?.map((header: any) => {
        if (typeof header === 'string') {
          return header;
        }
        if (typeof header === 'object' && Object.hasOwn(header, 'title')) {
          return header.title;
        }
        return '';
      }) || [],
    taperSchedule: taper?.taperSchedule
      ? taper?.taperSchedule.map((item: any) => ({
          values: item.values || [],
        }))
      : [],
  };
};
